import { LessonDefinition } from "../../types";

const lesson: LessonDefinition = {
  id: "set-up-your-report-preferences",
  courseId: "getting-started",
  order: 2,
  title: "Set up preferences",
  subtitle: "Make drafts sound like you",
  summary:
    "Set your name, rank, badge, perspective, and date and time formats before your first upload. The AI reads them for every draft, so a wrong setting repeats in every report.",
  learn: [
    "Fill in the identity fields the AI uses to refer to you",
    "Choose perspective, subject reference style, and date and time formats",
    "Save and know which fields matter most on day one",
  ],
  minutes: 4,
  sceneId: "set-up-your-report-preferences",
  tourId: "set-up-your-report-preferences",
  releasedAt: "2025-06-01T00:00:00.000Z",
  body: [
    {
      type: "paragraph",
      text: "Every narrative is generated against your Report Preferences. If perspective or time format is wrong, every draft comes out wrong until you fix it. Set the fields below once, then adjust as you see drafts.",
    },
    {
      type: "steps",
      items: [
        "Click the sliders icon next to **New Case**, or go to /preferences. The page is titled **Report Preferences**.",
        "Fill in **Include Name**, **Include Rank/Title**, and **Include Badge Number**. Each has a toggle and a value.",
        "Turn on **Abbreviate Rank** or **Capitalize Rank** if your department writes OFC. or SGT.",
        "Set **Narrative Perspective** to first person (\"I\") or third person (\"Officer Smith\").",
        "Set **Subject Reference Style**, which controls how victims, suspects, and witnesses are named after first mention.",
        "Set **Date Format** and **Time Format** to match your department's reports.",
        "Turn on **Include Topic Headings** if you want section headings in the draft, and set **Include Statutes** to your state so the Statutes panel works.",
        "Click **Save Preferences**.",
      ],
    },
    {
      type: "callout",
      tone: "tip",
      title: "Start with the big four",
      text: "Perspective, time format, date format, and rank are the settings officers change most after seeing their first draft. Get those right and the rest can wait.",
    },
    {
      type: "paragraph",
      text: "The same page holds your report templates, call sign, and common spellings, which the Your style course covers. If your department pushes preferences, some fields may already be filled in. You can still change the ones they left open.",
    },
    {
      type: "callout",
      tone: "note",
      text: "Changing a preference does not rewrite reports you already have. It applies to new drafts and to any report you regenerate.",
    },
  ],
  related: ["report-preferences-in-depth", "first-narrative-report", "report-templates"],
};

export default lesson;
